<template lang="pug">
  div(class='info-container')
    img(:src='agent.photo || require("../assets/uprightlogo.png")' :class='{logo: !agent.photo}')
    div(class='details-container')
      h3 {{agent.name}}
      p {{agent.bio}}
      div(class='contact-container')
        span(class="phone") <i class='el-icon-phone'></i>{{agent.phone}}
        span(class="email") <i class='far fa-envelope-open'></i> {{agent.email}}
</template>

<script>
export default {
  props: {
    agent: Object
  }
}
</script>

<style lang="scss" scoped>
img{
  width: 200px;
  height: 200px;
  margin: 15px 30px;
  border: 7px solid $color-accent;
  box-shadow: 2px 2px 4px gray;
  flex-shrink: 0;
  background-color: $color-primary-dark-40;
}

img.logo{
  object-fit: contain;
}

.info-container{
  display: flex;
  text-align: left;
  color: $color-primary;
  max-width: 900px;
  min-width: 700px;
  width: 100%;
}

.details-container{
  display: flex;
  flex-direction: column;
  // min-width: 300px;
  // flex-shrink: 1;
}

h3{
  font-size: 1.6em;
  margin-top: 15px;
  margin-bottom: 5px;
}

p{
  flex-grow: 1;
  font-style: italic;
}

.contact-container{
  margin-bottom: 19px;
  display: flex;
  flex-wrap: wrap;
}

.contact-container span{
  margin-right: 15px;
}

.phone, .email{
  color: white;
  background-color: $color-primary;
  font-size: 1.1em;
  padding: 6px 9px;
  margin-top: 3px;
}

i{
  color: $color-accent;
  display: inline;
}

@media only screen and (max-width: 730px) {
  img{
    margin: auto;
    box-shadow: none;
    flex-shrink: 0;
    display: block;
    padding: 0;
  }

  .info-container{
    display: block;
    width: 100%;
    min-width: auto;
    text-align: center;
    margin-bottom: 30px;
    padding: 10px 0;
    
  }

  .info-container:nth-child(even){
    background-color: #f1f1f5;
  }

  .contact-container{
    justify-content: center;
  }
}
</style>